const counterIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <path
      d="M9.21951 1.02439H10.7561V19.9756H9.21951V1.02439Z"
      fill="#6B00DF"
    />
    <path
      d="M6.50048 6.8261V14.8537H4.95989V8.71882L3.43031 9.30755V8.02006L6.33541 6.8261H6.50048Z"
      fill="#6B00DF"
    />
    <path
      d="M17.7745 9.92803V11.2683H12.8391V10.1236L15.1055 7.24176C15.3241 6.93881 15.4947 6.67421 15.6174 6.44796C15.7402 6.21787 15.8284 6.01271 15.882 5.83247C15.9357 5.6484 15.9626 5.47584 15.9626 5.31477C15.9626 5.06551 15.9338 4.85268 15.8763 4.67628C15.8188 4.49605 15.7325 4.35799 15.6174 4.26212C15.5062 4.16242 15.3682 4.11257 15.2033 4.11257C15.0039 4.11257 14.839 4.17392 14.7086 4.29664C14.5782 4.41935 14.4804 4.58808 14.4152 4.80283C14.3539 5.01374 14.3232 5.25342 14.3232 5.52185H12.7068C12.7068 5.0195 12.8085 4.55932 13.0117 4.14133C13.2188 3.72333 13.5083 3.39163 13.8803 3.1462C14.2561 2.89694 14.7067 2.77231 15.2321 2.77231C15.7459 2.77231 16.1754 2.86818 16.5205 3.05992C16.8695 3.25166 17.1322 3.52584 17.3086 3.88248C17.4888 4.23528 17.5789 4.65711 17.5789 5.14796C17.5789 5.4279 17.5425 5.70017 17.4697 5.96477C17.3968 6.22554 17.2933 6.4863 17.159 6.74707C17.0248 7.004 16.8599 7.26668 16.6643 7.53512C16.4688 7.80356 16.2483 8.08158 16.0028 8.36919L14.9099 9.92803H17.7745Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2958 17.0445H14.4795V18.407H15.3018C15.5179 18.407 15.702 18.453 15.854 18.5451C16.0061 18.6331 16.1221 18.7732 16.2022 18.9652C16.2822 19.1533 16.3222 19.4014 16.3222 19.7095C16.3222 19.9458 16.2854 20.1531 16.2117 20.3313H17.9543C17.9907 20.1438 18.0089 19.9445 18.0089 19.7335C18.0089 19.4014 17.9588 19.0973 17.8588 18.8212C17.7588 18.5451 17.6067 18.307 17.4026 18.1069C17.233 17.9372 17.0244 17.8021 16.777 17.7015C16.9663 17.5982 17.1328 17.4733 17.2766 17.3266C17.4767 17.1185 17.6287 16.8844 17.7328 16.6243C17.8408 16.3642 17.8948 16.0941 17.8948 15.814C17.8948 15.2698 17.7868 14.8136 17.5707 14.4455C17.3546 14.0734 17.0545 13.7933 16.6704 13.6052C16.2862 13.4131 15.84 13.3171 15.3318 13.3171C14.8797 13.3171 14.4675 13.4171 14.0954 13.6172C13.7232 13.8173 13.4271 14.0954 13.207 14.4515C12.9869 14.8076 12.8769 15.2258 12.8769 15.706H14.5695C14.5695 15.5019 14.6056 15.3278 14.6776 15.1838C14.7536 15.0357 14.8537 14.9217 14.9777 14.8417C15.1018 14.7616 15.2358 14.7216 15.3799 14.7216C15.5679 14.7216 15.724 14.7696 15.848 14.8657C15.9721 14.9617 16.0641 15.0937 16.1241 15.2618C16.1842 15.4299 16.2142 15.626 16.2142 15.85C16.2142 16.0901 16.1822 16.3002 16.1181 16.4803C16.0541 16.6603 15.9541 16.8004 15.818 16.9004C15.682 16.9965 15.5079 17.0445 15.2958 17.0445ZM12.8467 20.3313H14.5833C14.5181 20.1689 14.4855 19.9877 14.4855 19.7875H12.8049C12.8049 19.9803 12.8188 20.1616 12.8467 20.3313Z"
      fill="#6B00DF"
    />
  </svg>
);

const defaultCounterVariantIcon = (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3239 13.1092H15.7855V14.1787H11.4615V13.3305L13.6558 11.127C14.0799 10.7029 14.3933 10.2788 14.3933 9.74408C14.3933 9.16325 14.0706 8.88666 13.5728 8.88666C13.0288 8.88666 12.6416 9.24623 12.6416 9.94691L11.3601 9.95613C11.3601 8.56398 12.2821 7.7711 13.5636 7.7711C14.8543 7.7711 15.6841 8.5271 15.6841 9.74408C15.6841 10.5738 15.3061 11.1639 14.5408 11.9107L13.3239 13.1092Z"
      fill="#6B00DF"
    />
    <path
      d="M10.598 10.4632H9.48241L9.32568 11.4774H10.2568V12.4362H9.17816L8.9108 14.1787H7.89665L8.16402 12.4362H7.20519L6.93782 14.1787H5.92367L6.19104 12.4362H5.14001V11.4774H6.33855L6.49528 10.4632H5.47192V9.50439H6.6428L6.89172 7.8541H7.89665L7.64772 9.50439H8.61577L8.8647 7.8541H9.87885L9.62992 9.50439H10.598V10.4632ZM8.31153 11.4774L8.46826 10.4632H7.50021L7.34348 11.4774H8.31153Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.10623 8.04457C1.35599 9.87961 1.22778 11.91 1.74123 13.8249C2.25469 15.7397 3.38154 17.4336 4.94922 18.6471C6.51691 19.8606 8.43915 20.527 10.4216 20.5441C12.404 20.5612 14.3374 19.9283 15.9259 18.742C17.5143 17.5558 18.6703 15.8817 19.2168 13.976C19.7633 12.0704 19.6703 10.038 18.9519 8.19029C18.2335 6.34254 16.9294 4.78107 15.2391 3.745C13.5489 2.70893 11.5657 2.25529 9.59315 2.45354C9.19975 2.49308 8.84878 2.20622 8.80924 1.81282C8.7697 1.41942 9.05656 1.06844 9.44996 1.0289C11.734 0.799344 14.0303 1.32461 15.9874 2.52428C17.9445 3.72394 19.4546 5.53195 20.2864 7.67146C21.1182 9.81096 21.226 12.1642 20.5932 14.3707C19.9604 16.5773 18.6219 18.5158 16.7826 19.8893C14.9434 21.2628 12.7046 21.9957 10.4092 21.9759C8.11374 21.956 5.88801 21.1844 4.07279 19.7793C2.25756 18.3742 0.952794 16.4129 0.35827 14.1957C-0.236255 11.9785 -0.0878019 9.62752 0.780897 7.50272C0.930523 7.13674 1.34851 6.96135 1.71449 7.11098C2.08047 7.26061 2.25586 7.67859 2.10623 8.04457Z"
      fill="#6B00DF"
    />
  </svg>
);

const counterWithIconVariantIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5092 12.2476H12.9708V13.3171H8.64688V12.4689L10.8411 10.2654C11.2652 9.84132 11.5787 9.41722 11.5787 8.88249C11.5787 8.30166 11.256 8.02507 10.7582 8.02507C10.2142 8.02507 9.82698 8.38463 9.82698 9.08532L8.54547 9.09454C8.54547 7.70239 9.46742 6.90951 10.7489 6.90951C12.0397 6.90951 12.8694 7.66551 12.8694 8.88249C12.8694 9.71224 12.4914 10.3023 11.7262 11.0491L10.5092 12.2476Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.10623 7.06831C1.35599 8.90336 1.22778 10.9338 1.74123 12.8486C2.25469 14.7634 3.38154 16.4573 4.94922 17.6708C6.51691 18.8843 8.43915 19.5507 10.4216 19.5678C12.404 19.585 14.3374 18.952 15.9259 17.7658C17.5143 16.5796 18.6703 14.9055 19.2168 12.9998C19.7633 11.0941 19.6703 9.06179 18.9519 7.21404C18.2335 5.36629 16.9294 3.80481 15.2391 2.76874C13.5489 1.73267 11.5657 1.27903 9.59315 1.47729C9.19975 1.51683 8.84878 1.22996 8.80924 0.836561C8.7697 0.443158 9.05656 0.092187 9.44996 0.052647C11.734 -0.176913 14.0303 0.348356 15.9874 1.54802C17.9445 2.74768 19.4546 4.5557 20.2864 6.6952C21.1182 8.8347 21.226 11.1879 20.5932 13.3945C19.9604 15.6011 18.6219 17.5395 16.7826 18.913C14.9434 20.2865 12.7046 21.0195 10.4092 20.9996C8.11374 20.9798 5.88801 20.2082 4.07279 18.8031C2.25756 17.3979 0.952794 15.4366 0.35827 13.2194C-0.236255 11.0023 -0.0878019 8.65126 0.780897 6.52646C0.930523 6.16048 1.34851 5.9851 1.71449 6.13472C2.08047 6.28435 2.25586 6.70233 2.10623 7.06831Z"
      fill="#6B00DF"
    />
    <path
      d="M6.65854 10.5C6.65854 11.2072 6.08525 11.7805 5.37805 11.7805C4.67086 11.7805 4.09756 11.2072 4.09756 10.5C4.09756 9.79281 4.67086 9.21951 5.37805 9.21951C6.08525 9.21951 6.65854 9.79281 6.65854 10.5Z"
      fill="#6B00DF"
    />
    <path
      d="M17.4146 10.5C17.4146 11.2072 16.8414 11.7805 16.1342 11.7805C15.427 11.7805 14.8537 11.2072 14.8537 10.5C14.8537 9.79281 15.427 9.21951 16.1342 9.21951C16.8414 9.21951 17.4146 9.79281 17.4146 10.5Z"
      fill="#6B00DF"
    />
  </svg>
);

const counterPrefixIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9961 0C15.2276 0 18 2.26531 18 6.45918C18 10.6224 15.2276 13.0102 10.9961 13.0102H6.56031V21H3V0H10.9961ZM10.9961 9.88776C13.214 9.88776 14.3813 8.44898 14.3813 6.4898C14.3813 4.56123 13.214 3.12245 10.9961 3.12245H6.56031V9.88776H10.9961Z"
      fill="black"
    />
  </svg>
);

const counterUnitIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5205 0H19V12.5939C19 17.8439 15.9198 21 11.0143 21C5.93761 21 3 17.8439 3 12.5939V0H6.4795V12.5939C6.4795 16.0231 8.10517 17.7832 11.0143 17.7832C13.8948 17.7832 15.5205 16.0231 15.5205 12.5939V0Z"
      fill="black"
    />
  </svg>
);

const counterSuffixIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.88368 5.7382C6.88368 10.5751 18 6.72961 18 15.2318C18 18.7468 14.9606 21 10.4859 21C5.78612 21 3 18.7468 3 14.721L6.4334 14.7511C6.4334 16.7639 7.89681 17.9056 10.6548 17.9056C13.1313 17.9056 14.5666 16.9442 14.5666 15.2318C14.5666 10.1845 3.45028 14.03 3.45028 5.82833C3.42214 2.34335 6.32083 0 10.6266 0C15.0169 0 17.7186 2.3133 17.7186 6.18884H14.2852C14.2852 4.08584 12.9062 3.09442 10.5704 3.09442C8.03752 3.09442 6.88368 4.05579 6.88368 5.7382Z"
      fill="black"
    />
  </svg>
);

export {
  counterIcon,
  defaultCounterVariantIcon,
  counterWithIconVariantIcon,
  counterPrefixIcon,
  counterUnitIcon,
  counterSuffixIcon,
};
